import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Card, CardMedia } from '@mui/material';

import {
  faceDownCardIconSx,
  faceDownCardMediaSx,
  faceDownCardRootSx,
  faceDownCardSelectedIndicatorSx,
} from './FaceDownCard.styles';

interface Props {
  index: number;
  selected: boolean;
  cardBack: string;
  onToggle: () => void;
}

function FaceDownCard({ index, selected, cardBack, onToggle }: Props) {
  const handleKey = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle();
    }
  };

  return (
    <Card
      onClick={onToggle}
      onKeyDown={handleKey}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      aria-label={`Face-down card ${index + 1}, click to select`}
      sx={faceDownCardRootSx(selected)}
    >
      <CardMedia component="img" image={cardBack} alt="" sx={faceDownCardMediaSx} />
      {selected && (
        <Box data-testid="selected-indicator" sx={faceDownCardSelectedIndicatorSx}>
          <CheckCircleIcon sx={faceDownCardIconSx} />
        </Box>
      )}
    </Card>
  );
}

export default FaceDownCard;
